import Vue from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";

// Fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExpandAlt, faExclamationTriangle, faSpinner, faEnvelope, faPhoneAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp, faFacebook, faTwitter, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import "./assets/css/main.min.css";

library.add(faExpandAlt, faExclamationTriangle, faSpinner, faEnvelope, faPhoneAlt, faGlobe);
library.add(faWhatsapp, faFacebook, faTwitter, faLinkedin, faInstagram, faYoutube);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
	vuetify,
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount("#app");
